import { View } from "@/classes/inbox/View";
import { orderBy, query, Query, where } from "firebase/firestore";

export class ViewSnoozed extends View {
  constructor() {
    super("Zurückgestellt");
    this.snoozedVisible = true;
  }

  async getQuery(): Promise<Query> {
    return query(
      this.defaultQuery,
      where("snoozed", ">", new Date()),
      orderBy("snoozed", "asc")
    );
  }
}
